export type CatalogTier = "BACK" | "MID" | "FRONT";

export enum SINGLE_PRICES {
  BACK = "$0.69",
  MID = "$0.99",
  FRONT = "$1.29",
}
